import React from 'react'
import IndiaTrident from './IndiaTrident'
import India from './India'
import Other from './Other'
import { useSelector } from 'react-redux';


function SubmitInvoice(props) {
	let tenant = useSelector(state=>state.auth.config.tenant);
	if ((tenant === 'TRDT') && (props.currency === 'INR') && props.poId)
		return  <IndiaTrident {...props}/>
	else if(props.currency === "INR") {
		return (<India {...props}/>)
	}else{
		return (<Other {...props}/>)
	}
}


export default SubmitInvoice;
